import styled from "styled-components";

const Modal = ({ children, isOpen = true }: { [key: string]: any }) => {
  return isOpen ? (
    <Wrapper id="custom-modal" className="custom-modal">
      <div className="custom-modal-content">{children}</div>
    </Wrapper>
  ) : (
    <></>
  );
};

export default Modal;

const Wrapper = styled.div`
  .custom-modal {
    position: fixed;
    z-index: 1;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .custom-modal-content {
    background-color: #3C3C3CCC;
  }
`;
